import styled from "styled-components";

const Columns = styled.div`
  display: flex;
  width: 100%;
`;
export const Column = styled.div`
  flex: 1 1 50%;
`;
const LeftColumn = styled(Column)`
  margin-right: ${p => p.theme.ContractDetails.margin};
`;
const RightColumn = styled(Column)`
  margin-left: ${p => p.theme.ContractDetails.margin};
  text-align: ${p => p.align || "left"};
`;
Column.Wrapper = Columns;
Column.Left = LeftColumn;
Column.Right = RightColumn;

export default Column;
